export var createMuiFormControlLabelOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginLeft: spacing(-1),
            marginRight: spacing(3),
        },
        label: {
            "[class*='MuiCheckbox-root'] + &, [class*='MuiRadio-root'] + &": {
                marginLeft: spacing(2),
            },
        },
    });
};
//# sourceMappingURL=MuiFormControlLabel.js.map